module.exports = __webpack_public_path__ + "static/media/check_white.e8802d33.svg";